import { BaseUniDriver, UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { tooltipDriverFactory as coreTooltipDriverFactory } from '../internal/WixUiCoreComponents/components/CoreTooltip/CoreTooltip.uni.driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';

export interface TooltipDriver extends BaseUniDriver {
  /** returns true if trigger element exists on the DOM */
  exists(): Promise<boolean>;
  /** returns true if tooltip element exists on the DOM */
  tooltipExists(): Promise<boolean>;
  /** mouse over the target element */
  mouseEnter(): Promise<void>;
  /** mouse leaves the target element */
  mouseLeave(): Promise<void>;
  /** clicks outside the tooltip target */
  clickOutside(): Promise<void>;
  /** returns tooltips content value in string */
  getTooltipText(): Promise<string>;
}

export const tooltipDriverFactory = (
  base: UniDriver,
  body: UniDriver,
): TooltipDriver => {
  return {
    ...baseUniDriverFactory(base),
    ...coreTooltipDriverFactory(base, body),
  };
};
